module.exports = __webpack_public_path__ + "static/media/screen_tiles_4.fc1f7659.svg";